import React from 'react'
import App from './App'
import UserAgentCheckWrapper from './wrapper/UserAgentCheckWrapper'

const AppWarpper = () => {
  return (
    <UserAgentCheckWrapper>
      <App />
    </UserAgentCheckWrapper>
    
  )
}

export default AppWarpper